import { useTranslation } from "gatsby-plugin-react-i18next";

export const useResetPwdAcademia = () => {
  const {t} = useTranslation(['trace-academia']);
  return {
    mention: t('An email will be sent to you to create your new password.'),
    title: t('ACTIVATE YOUR ACCOUNT'),
  };
};
